import { createSlice } from '@reduxjs/toolkit';
import { UserNotificationsDetailStateType } from 'src/types/userNotificationsDetail';

const initialState: UserNotificationsDetailStateType = {
    data: null,
    loading: false,
    error: false,
};

export const myNotificationsSlice = createSlice({
    name: 'myNotifications',
    initialState,
    reducers: {
        getMyNotificationsFetch: (state) => {
            state.loading = true;
            state.error = false;
        },
        getMyNotificationsFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        getMyNotificationsFetchFailure: (state) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
        updateMyNotificationsFetch: (state, _action) => {
            state.loading = true;
            state.error = false;
        },
        updateMyNotificationsFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        updateMyNotificationsFetchFailure: (state) => {
            state.loading = false;
            state.error = true;
        },
        clearMyNotifications: () => initialState,
    },
});

export const {
    getMyNotificationsFetch,
    getMyNotificationsFetchSuccess,
    getMyNotificationsFetchFailure,
    updateMyNotificationsFetch,
    updateMyNotificationsFetchSuccess,
    updateMyNotificationsFetchFailure,
    clearMyNotifications,
} = myNotificationsSlice.actions;

export default myNotificationsSlice.reducer;
